/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSteam: {
  name: 'steam';
  data: string;
} = {
  name: 'steam',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 4a2.5 2.5 0 0 1 5 0 .5.5 0 0 0 .007.085.5.5 0 0 0 .66.557A2.5 2.5 0 1 1 12 9.5a.5.5 0 0 0 0 1 3.5 3.5 0 1 0-.53-6.96 3.5 3.5 0 0 0-6.94 0A3.5 3.5 0 1 0 4 10.5a.5.5 0 0 0 0-1 2.5 2.5 0 1 1 .833-4.858.5.5 0 0 0 .66-.557A.503.503 0 0 0 5.5 4ZM7 6.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V7a.5.5 0 0 1 .5-.5Zm2 3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
